import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { getDefaultTimeByWaterTrend } from '@/pages/WgqAllMaps/utils';
import { EchartsWithTheme, Empty, Tooltip, useTheme } from '@maxtropy/components';
import { apiV2WaterMapDataCostTrendPost } from '@maxtropy/device-customer-apis-v2';
import { useRequest } from 'ahooks';
import React, { useContext, useMemo } from 'react';
import { ShareDataWaterMapContext } from '../..';
import { ShareConfigDataWaterContext } from '../../../..';
import { getChartOption } from './charts';
import styles from './index.module.scss';
import spin_icon from '../../../../../../imgs/spin_icon.png';
import cost_icon from '../../../../../../imgs/cost_icon.png';
import { Progress } from 'antd';
import { formatThousandAndUnit, keepOnePercentOrLine } from '@/utils/utils';

const CostTrend = () => {
  const theme = useTheme();
  const { timeResolution, value } = useContext(ShareDataWaterMapContext);
  const { configDetail } = useContext(ShareConfigDataWaterContext);

  // 成本趋势
  const { data: costTrendData, loading } = useRequest(
    async () => {
      return await apiV2WaterMapDataCostTrendPost({
        energyUnitId: configDetail?.energyUnitId1,
        energyUnitGroupId: configDetail?.energyGroupId1,
        periodId: configDetail?.periodId,
        timeResolution: timeResolution,
        fromTime: getDefaultTimeByWaterTrend(timeResolution!, value).startTime,
        toTime: getDefaultTimeByWaterTrend(timeResolution!, value).endTime,
      });
    },
    {
      ready: !!timeResolution && !!value && !!configDetail,
      refreshDeps: [timeResolution, value, configDetail],
    }
  );

  // 图表
  const chartOption = useMemo(() => {
    return getChartOption(costTrendData, timeResolution);
  }, [costTrendData, timeResolution]);

  // 新水
  const tapWater = useMemo(() => {
    return costTrendData?.detailList?.find(c => c.energyMediumId === 2001);
  }, [costTrendData]);

  // 中水
  const reclaimedWater = useMemo(() => {
    return costTrendData?.detailList?.find(c => c.energyMediumId === 2005);
  }, [costTrendData]);

  return (
    <div>
      <div className={styles.right_wrapper}>
        <div className={styles.top}>
          <div className={styles.icon}>
            <img src={spin_icon} className={styles.icon_spin} alt="" />
            <img src={cost_icon} className={styles.icon_icon} alt="" />
          </div>
          <div className={styles.label}>总成本({formatThousandAndUnit(costTrendData?.totalCost).unit}元):</div>
          <div className={styles.value}>{formatThousandAndUnit(costTrendData?.totalCost).value}</div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.bottom_left}>
            <div className={styles.bottom_left_top}>
              <div className={styles.label}>
                {tapWater ? '自来水' : '--'}({formatThousandAndUnit(tapWater?.energyUseCost).unit}元)
              </div>
              <div className={styles.value}>
                <Progress
                  percent={tapWater ? (tapWater?.rate ?? 0) * 100 : undefined}
                  showInfo={false}
                  size="small"
                  strokeColor={'#16DD8E'}
                />
              </div>
            </div>
            <div className={styles.bottom_left_bottom}>
              <Tooltip title={formatThousandAndUnit(tapWater?.energyUseCost).value}>
                <div className={styles.value}>{formatThousandAndUnit(tapWater?.energyUseCost).value}</div>
              </Tooltip>
              <div className={styles.rate}>
                <Tooltip title={`${keepOnePercentOrLine(tapWater?.rate ?? 0)}%`}>
                  <span className={styles.rate_value}>{keepOnePercentOrLine(tapWater?.rate ?? 0)}%</span>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className={styles.bottom_right}>
            <div className={styles.bottom_right_top}>
              <div className={styles.label}>
                {reclaimedWater ? '中水' : '--'}({formatThousandAndUnit(reclaimedWater?.energyUseCost).unit}元)
              </div>
              <div className={styles.value}>
                <Progress
                  percent={reclaimedWater ? (reclaimedWater?.rate ?? 0) * 100 : undefined}
                  showInfo={false}
                  size="small"
                  strokeColor={'#FFCB47'}
                />
              </div>
            </div>
            <div className={styles.bottom_right_bottom}>
              <Tooltip title={formatThousandAndUnit(reclaimedWater?.energyUseCost).value}>
                <div className={styles.value}>{formatThousandAndUnit(reclaimedWater?.energyUseCost).value}</div>
              </Tooltip>
              <div className={styles.rate}>
                <Tooltip title={`${keepOnePercentOrLine(reclaimedWater?.rate ?? 0)}%`}>
                  <span className={styles.rate_value}>{keepOnePercentOrLine(reclaimedWater?.rate ?? 0)}%</span>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SubTitle title="用水成本">
        <div className={styles.echarts_wrapper}>
          <EchartsWithTheme
            empty={{
              isShowEmpty: !costTrendData,
              emptyNode: <Empty />,
            }}
            loading={loading}
            theme={theme}
            style={{ height: 160 }}
            option={chartOption}
          />
        </div>
      </SubTitle>
    </div>
  );
};

export default CostTrend;
